module.exports = __webpack_public_path__ + "static/hr-e5f00ec808cecc1b7e215972fa27930a.png";